import { defineStore } from 'pinia'
import {getUserInfo, getUserRankList, setUserCurseUpdate} from "../api";
import { isSameDay } from "./time";
import { generateUUID } from "./cryptoHelper";

export default {

}

export const ThemeColorList = [
		{id: 0, title: "System Default — Medium School Blue", color: "#2563EB"},
        {id: 1, title: "Deep Teal Green", color: "#223E8A"},
        {id: 2, title: "Soft Learning Lavender", color: "#A89CC8"},
        {id: 3, title: "Neutral Ash Gray", color: "#A3ABB4"},
        {id: 4, title: "Medium School Blue", color: "#6F8CBF"},
        {id: 5, title: "Dark Blue-Gray Slate", color: "#1F2937"},
        {id: 6, title: "Classic Navy Blue", color: "#1E3A8A"},
        {id: 7, title: "Near-Black Charcoal", color: "#0F172A"},
      ]

//设置cookies
export function setCookie(name, value) {
	let expires = "";
	const date = new Date();
	date.setTime(date.getTime() + (100 * 365 * 24 * 60 * 60 * 1000));
	expires = "; expires=" + date.toUTCString();
	document.cookie = name + "=" + value + expires + "; path=/; domain=.germantutor.ai";
}


//全局参数，不会持久化保存
export const globalData = defineStore('globalData', {
	state: () => {
		return {
			ref: "",
			loginReferer: "/talk",	//登录的来源地址
			
		}
	},
	getters: {
		
	},
})

//全局参数，会持久化保存
export const globalConfig = defineStore('globalConfig', {
	state: () => {
		return {
			accessCookies: null,	//是否接受cookies
			langCode: null,			//用户选择的语言
			lastTeacherID: null,		//最后聊天的老师的id
			lastCountryID: null,		//最后聊天的老师国家id，注册使用
			lastTeacher: {},			//最后聊天的老师
			country: null,			//最后聊天的老师国家信息
			showTalkInput: null,	//聊天输入框的缩放
			teacher: {},			//最后聊天的老师信息
			tempUserID: generateUUID(),		//临时的用户id
			lastTrainSelected: null,		//最后聊天练习的等级
			hasSendMessage: false,	//是否发送过文字消息
			channel: null,			//进入的渠道，不同的渠道会有不同的sdk加载
			metaJson: null,			//META推广的json数据
			ref: null,				//该用户访问的来源，标记折扣等，注册会绑定
			showTranslateTip: true,	//标记点击过翻译按钮，不再显示翻译提示
			showTranslateOpenTip: true,	//是否显示打开翻译提示
			showDownloadPDFTip: true,	//标记点击过下载按钮，不再显示下载提示
			isTranslate: null,		//是否开启翻译,
			hasShowTrainFinger: false,	//是否已显示训练提示
			hasShowAutoTrainFinger: false, //是否已显示自动模式的训练提示
			hasClickQuickMsgType: false,	//是否点击了快速消息类型按钮
			showLiveTranslateTip: true,	//是否显示实时翻译提示
			lastLoginUserID: null,	//最后登录的用户id
			hasChangeSpeedID: false,	//是否已经选择过消息速度
			payType: 1,				//付费类型，1. stripe, 2. paypal
			orgInfo: null,			//未登录用户获取机构配色信息等
			isFromOrg: false,		//是否是从机构推广链接进来
		}
	},
	getters: {
		themeColor: (state) => {
			var index = 0
			if (state.orgInfo && state.orgInfo.page_color_type) {
				index = state.orgInfo.page_color_type
			}
			return ThemeColorList[index].color
		}
	},
	actions: {
		logout() {
			this.lastTrainSelected = null
			this.tempUserID = generateUUID()	//重新生成临时用户id
			this.ref = null
			this.isTranslate = null
			this.hasShowTrainFinger = false
			this.hasShowAutoTrainFinger = false
			this.hasChangeSpeedID = false
			this.showDownloadPDFTip = true
			this.orgInfo = null
			this.isFromOrg = false
		},
	},
	persist: true
})

//最后聊天的老师信息
export const lastTeacherGreeting = defineStore('lastTeacherGreeting', {
	state: () => {
		return {
			lastTeacherInfo: [{
				teacher_id: 0,
				time: new Date().getTime()
			}]
		}
	},
	getters: {

	},
	actions: {
		showGreeting(teacher_id) {
			var targetTeacher = this.lastTeacherInfo.find(item => item.teacher_id === teacher_id);
			if (targetTeacher) {
				//当天没打过招呼
				return !isSameDay(new Date(targetTeacher.time), new Date())
			} else {
				return true;
			}
		},

		updateTeacherInfo(teacher_id) {
			this.lastTeacherInfo = this.lastTeacherInfo.filter(item => item.teacher_id != teacher_id)
			this.lastTeacherInfo.unshift({
				teacher_id: teacher_id,
				time: new Date().getTime()
			})
		}
	},
	persist: true
})

//用户信息
export const userInfo = defineStore('userInfoStore', {
	state: () => {
		return {
			id: 9999,
			user_name: '',
			name: '',
			email: '',
			face_url: '',
			login_access_token: '',
			phone: '',
			teacher_id: null,
			is_vip: false,
			expire_date: '',
			is_lock: false,
			is_bind_phone: false,
			subscription_management: '',
			my_read: 1,
			course_read: 1,
			speed_level: 1,		//聊天语速，1：正常 2：快 3：慢
			course_number_read: 0,	//
			course_image_read: 0,	//
			user_id_str: '',
			is_adolescent: 0,		//青少年模式
			subscribe_url_show: false,
			subscribe_url: '',
			is_new_user: false,
			discount_code: '',
			subscribe_type: -1,  //-1（非会员），0（日订阅），1（月订阅），2（年订阅），3（周订阅）
			voice_num: 0,
			subscribe_bill_url: '',
			sub_pop_status: 0,
			text_num: 0,
			show_text_package: false,
			show_voice_package: false,
			sex: 0,	//0未选择，１:Ｍale , 2: Female , 3:Other, 
			is_load_google_ads: false,
			show_upgrade_package: false,
			chat_num: 0,	//聊天次数
			country_id: 0,
			chat_text_num: 0,	//文字聊天次数
			chat_voice_num: 0,	//语音聊天次数
			is_click_voice_hand: false,	//是否点击过语音引导小手
			is_lifetime_vip: false,	//是否是终身会员
			lifetime_price_id: 0,	// 升级终身会员VIP对应的配置ID
			is_click_chat_hand: false, //是否点击过语聊引导小手
			register_day:0,	//当前注册第几天
			is_vest: false,	//是否是马甲用户
			is_auto_subscribe_show: false,	//是否自动弹订阅弹层
			is_show_pronunciation_hand: false,	//是否显示发音引导小手
			lifetime_grade_info: {},
			language_level: 0,
			show_upgrade_lifetime_button: false,
			is_economic_country: false,		//是否是落后国家
			is_super_country: false,		//是否是富裕国家
			one_month_upgrade_year_auto_show: false,	//弹窗月费升级年费
			no_stripe_one_month_upgrade_btn_show: true,	//显示月费升级年费按钮
			logo_info: {
				url: "",
				name: ""
			},
			is_show_org_btn: false,			//是否显示机构按钮
			org_user_type: 0,				//0: 普通用户， 1：机构用户
			is_org_leader: false,			//是否是机构负责人
			is_show_family_pay_btn: false,	//家庭套餐支付弹层按钮
			is_show_family_info_btn: false,	//家庭套餐信息弹层按钮 
			family_discount_code: "",		//优惠信息
			page_color_type: 0,				//主题颜色
		}
	},
	getters: {
		isLogin: (state) => {
			return state.id > 0 && state.id != 9999  && state.login_access_token != ''
		},
		themeColor: (state) => {
			return ThemeColorList[state.page_color_type].color
		}
	},
	actions: {
		logout() {
			globalConfig().logout()
			this.$reset()
			localStorage.removeItem("userInfoStore");
			setCookie("hitalk_is_login", "0")
		},
		updateUser(complete = null) {
			getUserInfo().then(res => {
				if (complete) {
					complete(res)
				}
			})
		}
	},
	persist: true
})

// 聊天选的国家
export const selectTalkCountry = defineStore('selectTalkCountryStore', {
	state() {
		return {
			country: null
		}
	}
})

// 练习进度
export const courseStore = defineStore('courseStoreStore', {
	state() {
		return {
			wordText: '',
			wordDsc: '',
			// wordText: '我喜欢这个食物',
			// wordDsc: 'I like the food',
			isShowContents: false,
			isAllDone: false, // 全部练习完
			statementIndex: 0,// 已练习题目总数
			totalQuestionsCount: 0, // 题目总数
			inputTextList: [],
			inputValueList: [],
			wordDscList: [],
			exerciseList: [],
			course_id: 0,
			gradeType: 1,
			subjectId: 0,
			teacher: null,
			is_pay: false,
			course_title: '',
			is_tip: false,
			course_list: [],
			chat_list: [],
			tip_info: {}
		}
	},
	actions: {
		getRanking(type, complete){
			getUserRankList().then(res => {
				this.chat_list = res.chat_list
				this.course_list = res.course_list
				if (complete) {
					complete()
				}
			})
		},
		getInputTextList(it) {
			const hasSpace = this.wordDsc.includes(" ");
			let list = []
			if (hasSpace) {
				let data = this.wordDsc.split(' ')
				this.wordDscList = data
				data.forEach(item => {
					let obj = {
						text: '',
						isActive: false,
						incorrect: false,
					}
					list.push(obj)
				})
			} else {
				let obj = {
					text: '',
					isActive: false,
					incorrect: false,
				}
				this.wordDscList = [this.wordDsc]
				list.push(obj)
			}

			list[0].isActive = true
			this.inputTextList = list
			if (it && it != 'exercise') {
				setUserCurseUpdate({teacher_id: globalConfig().lastTeacherID, course_id: this.course_id, number: it.sort_id, class_id: it.id, class_type: this.gradeType}).then(res => {
					this.is_pay = res.is_pay
					this.is_tip = res.is_tip
				})
			}

		},
		setInputTextList(index) {
			if (index <= this.inputTextList.length - 1) {
				this.inputTextList[index].isActive = true
			}
		},
		setInputText(index, text) {
			this.inputTextList[index].text = text
		},
		setInputTextNotActive(index) {
			this.inputTextList[index].isActive = false
		},
		setInputTextDel(index) {
			let str = this.inputTextList[index].text
			this.inputTextList[index].text = str.slice(0, -1);
			if (this.inputTextList[index].text.length == 0) {
				this.inputTextList[index].isActive = false
				return 'null'
			}
			return 'str'
		},
		setInputValue(val) {
			let text = val.replace(/[`‘’]/g, "'");
			let arry = text.split(' ')
			if (arry.length <= this.inputTextList.length) {
				this.inputValueList = arry
				if (arry.length == 1) {
					this.inputTextList[0].isActive = true
					this.inputTextList[0].text = arry[0]
				}
				this.inputTextList.forEach(item => {
					item.isActive = false
				})
				arry.forEach((item, index) => {
					this.inputTextList[index].text = item
				})
				this.inputTextList[arry.length - 1].isActive = true
			}
			if (arry.length == this.inputTextList.length) {
				return  false
			} else  {
				return true
			}

		},
	//	校验
		getWordCheck() {
			this.inputTextList.forEach((item, index) => {
				this.inputTextList[index].isActive = false
				let result = this.wordDscList[index].toUpperCase().replace(/\（[^\（\）]*\）/g, '');
				let parts = this.wordDscList[index].toUpperCase().split('；');
				if (parts.length > 1) {
					if (item.text.toUpperCase() != parts[0]) {
						this.inputTextList[index].incorrect = true
					}
				} else {
					if (item.text.toUpperCase() != result) {
						this.inputTextList[index].incorrect = true
					}
				}
			})
		},
	//	下一题
		setNextSubject(type) {
			if(this.is_pay) {
				return
			}
			if (this.statementIndex == this.exerciseList.length - 1) {
				this.isAllDone = true
				return 'over'
			}
			console.log(type)

			if (!type) {
				this.statementIndex = this.statementIndex + 1
				this.wordText = this.exerciseList[this.statementIndex].english
				this.wordDsc = this.exerciseList[this.statementIndex].chinese
				this.subjectId = this.exerciseList[this.statementIndex].first_id
				this.recoveryFn()
				courseStore().getInputTextList(this.exerciseList[this.statementIndex])
			}

		},
		// 上一题
		setPrevSubject(type) {
			if (this.statementIndex == 0) {
				return 'over'
			}

			if (!type) {
				this.statementIndex = this.statementIndex - 1
				this.subjectId = this.exerciseList[this.statementIndex].first_id
				this.wordText = this.exerciseList[this.statementIndex].english
				this.wordDsc = this.exerciseList[this.statementIndex].chinese
				this.recoveryFn()
				courseStore().getInputTextList(this.exerciseList[this.statementIndex])
			}
		},
	//	菜单选择题目
		selectSubject(it, index) {
			this.statementIndex = index
			this.wordText = this.exerciseList[this.statementIndex].english
			this.wordDsc = this.exerciseList[this.statementIndex].chinese
			this.subjectId = this.exerciseList[this.statementIndex].first_id
			this.isShowContents = false
			courseStore().getInputTextList(it)
		},
		// 恢复
		recoveryFn() {
			this.inputTextList.forEach(item => {
				item.text = ''
				item.isActive = false
				item.incorrect = false
			})
		},
		recoveryFocusFn() {
			this.isShowContents = false
			// this.inputTextList.forEach(item => {
			// 	item.isActive = false
			// })
		},
		emptyFn() {
			this.wordDsc = ''
			this.wordText = ''
			this.wordDscList = ['']
			this.statementIndex = 0
			this.inputTextList = [
				{
					text: '',
					isActive: false,
					incorrect: false
				}
			]
			// this.inputTextList.forEach(item => {
			// 	item.text = ''
			// 	item.isActive = false
			// 	item.incorrect = false
			// })
		}
	}
})
